import React, { useState, useEffect } from 'react';

const ErrorBoundary = ({ children }) => {
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    const handleError = (event) => {
      setHasError(true);
      // Optionally log error: event.error
    };
    window.addEventListener('error', handleError);
    return () => window.removeEventListener('error', handleError);
  }, []);

  if (hasError) {
    return (
      <div style={{ padding: 32, textAlign: 'center' }}>
        <h1>Something went wrong.</h1>
        <button onClick={() => window.location.reload()}>Refresh</button>
      </div>
    );
  }
  return children;
};

export default ErrorBoundary; 